module.exports = __webpack_public_path__ + "static/media/euthystira_brachyptera_004_APA.3daaa0f8.mp3";